import { useState } from 'react'
import { useParams } from 'react-router-dom'

import { can } from '@/features/auth/permissions'
import { useSession } from '@/features/auth/use-session'
import { PortfolioTable } from '@/features/portfolio/components/PortfolioTable'
import { ProjectForm } from '@/features/projects/components/ProjectForm'
import { EmptyState, ErrorState, SkeletonRows } from '@/shared/components/data'
import { Button } from '@/shared/components/ui'
import { useT } from '@/shared/i18n'

import { useCompanyProjects } from '../api'

export function CompanyProjectsTab() {
  const t = useT()
  const { companyId = '' } = useParams()
  const query = useCompanyProjects(companyId)
  const { me } = useSession()
  const [creating, setCreating] = useState(false)

  // Acá la empresa ya está decidida: el formulario no vuelve a preguntarla.
  const alta = can(me, 'project:create', { companyId }) ? (
    <div className="flex justify-end">
      <Button variant="primary" onClick={() => setCreating(true)}>
        {t('projects.new')}
      </Button>
    </div>
  ) : null

  if (query.isPending) return <SkeletonRows rows={6} />
  if (query.isError) return <ErrorState error={query.error} onRetry={() => void query.refetch()} />

  const projects = query.data ?? []

  return (
    <div className="flex flex-col gap-3">
      {alta}
      <ProjectForm open={creating} onClose={() => setCreating(false)} companyId={companyId} />
      {projects.length === 0 ? (
        <EmptyState
          title={t('companies.projects.emptyTitle')}
          description={t('companies.projects.emptyDescription')}
        />
      ) : (
        <PortfolioTable projects={projects} />
      )}
    </div>
  )
}
